import React from "react";
import MotionScenePlayback from "./MotionScenePlayback";

/**
 * MotionScene plugin — plays a procedurally animated scene authored by the
 * backend's motionize flow (infographic scene modal, fourth tab).
 *
 * The box owns the whole scene: the document paints every pixel including its
 * background, so there is no toolbar and nothing to edit element by element.
 * Changes go back through the chat/regenerate path, which rewrites the
 * document and swaps `state.htmlUrl`.
 *
 * Single file serves both editor and visor; playback is deterministic in
 * recorder mode because the host drives time (same pattern as Character and
 * RecorderCanvasVideo).
 */
export function MotionScene(base) {
  return {
    getConfig() {
      return {
        name: "MotionScene",
        displayName: "Motion Scene",
        category: "media",
        flavor: "react",
        needsConfigModal: false,
        needsTextEdition: false,
        initialWidth: "100%",
        initialHeight: "100%",
        icon: "animation",
      };
    },

    getToolbar() {
      // Content is generated server-side; there is no per-element editing.
      return { main: { __name: "MotionScene", accordions: {} } };
    },

    getInitialState() {
      return {
        htmlUrl: "",
        durationSec: 0,
        label: "",
        engineVersion: "1",
        timeSource: "playhead",
      };
    },

    getRenderTemplate(state, props) {
      return (
        <MotionScenePlayback
          state={state}
          boxId={(props && props.id) || null}
          visor={props && props.visor === true}
          visorCurrentTime={
            props && typeof props.visorCurrentTime === "number" ? props.visorCurrentTime : null
          }
          visorPlaying={props && props.visorPlaying}
        />
      );
    },
  };
}
